import VueGoodTablePlugin from 'vue-good-table-next'
import Toast from 'vue-toastification'
import Lottie from 'vue-lottie'
import router from './router'
import App from './App.vue'
import { createApp, provide } from 'vue'
import { mask } from 'vue-the-mask'
import { storeApp } from './store'
import 'vue-good-table-next/dist/vue-good-table-next.css'
import 'vue-toastification/dist/index.css'
import './registerServiceWorker'
import './styles/toasts.scss'
import './styles/index.css'
import * as error from './utils/error-log.js'
import './installPrompt.js'

const toastConfig = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: false,
  rtl: false
}

const app = createApp(App)

app.config.productionTip = false

app
  .directive('mask', mask)
  .component('lottie', Lottie)
  .use(Toast, toastConfig)
  .use(VueGoodTablePlugin)
  .use(router)
  .use(storeApp)
  .mount('#app')
